import React from 'react';
import './nav.css';
import { GoHome } from 'react-icons/go'
import { RiUser6Line } from 'react-icons/ri'
import { AiOutlineBook } from 'react-icons/ai'
import { RiServiceLine } from 'react-icons/ri'
import { MdOutlineContactPhone } from 'react-icons/md'
import { useState } from 'react';
// extra icons
import { RiAwardLine } from 'react-icons/ri'
import { RiMailSendLine } from 'react-icons/ri'
const Nav = () => {
  const [activeNav, setActiveNav] = useState('#');
  return (
    // <nav>
    //   <ul className='navigation'>
    //     <li>
    //       <a href='#'>
    //         <span className='icon'><GoHome/></span>
    //         <span className='text'>Home</span>
    //       </a>
    //     </li>
    //     <li>
    //       <a href='#'>
    //         <span className='icon'><RiUser6Line/></span>
    //         <span className='text'>About</span>
    //       </a>
    //     </li>
    //     <li>
    //       <a href='#'>
    //         <span className='icon'><AiOutlineBook/></span>
    //         <span className='text'>Experience</span>
    //       </a>
    //     </li>
    //     <li>
    //       <a href='#'>
    //         <span className='icon'><RiServiceLine/></span>
    //         <span className='text'>Services</span>
    //       </a>
    //     </li>
    //     <li>
    //       <a href='#'>
    //         <span className='icon'><MdOutlineContactPhone/></span>
    //         <span className='text'>Contact</span>
    //       </a>
    //     </li>
    //   </ul>

    // </nav>

    <nav>
      <ul>
        <li>
          <div className='tool'>Home</div>
          <a href='#' onClick={() => setActiveNav('#')} className={activeNav === '#' ? 'active' : ''}><GoHome /></a>
        </li>
        <li>
          <div className='tool'>about</div>
          <a href='#about' onClick={() => setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ''}><RiUser6Line /></a>
        </li>        <li>
          <div className='tool'>experience</div>
          <a href='#experience' onClick={() => setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : ''}><AiOutlineBook /></a>
        </li>
        <li>
          <div className='tool'>services</div>
          <a href='#services' onClick={() => setActiveNav('#services')} className={activeNav === '#services' ? 'active' : ''}><RiServiceLine /></a>
        </li>
        <li>
          <div className='tool'>contact</div>
          <a href='#contact' onClick={() => setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : ''}><MdOutlineContactPhone /></a>
        </li>
      </ul>
    </nav>
  )
}

export default Nav